import { gql } from '@apollo/client';

export const GET_USER = gql`
  query GetRealtorProfile {
    getRealtorProfile {
      message
      status
      trialValid
      trialPeriod
      isCompliant
      stripeLink
      trialValid
      trialPeriod
      data {
        city
        country
        postalCode
        communicationAddress
        email
        firstName
        id
        isEmailVerified
        isPhoneVerified
        lastName
        noOfUnits
        phone
        selfie
        status
        stripeAccountStatus
        documents {
          approveBy
          description
          docKey
          documentId
          documentType
          fileName
          file_ext
          frontImage
          id
          note
          provider
          realtorId
          reason
          status
          test
          uri
          issueDate
          meta {
            contentType
            docOption
            file_size
            isOthers
          }
        }
      }
    }
  }
`;

export const FORGOT_PASSWORD_BY_EMAIL = gql`
  query ForgotPasswordRealtor($email: String!) {
    forgotPasswordRealtor(email: $email) {
      status
      message
    }
  }
`;

export const GET_LANDLORD_DASHBOARD = gql`
  query GetLandlordDashboard(
    $limit: Int
    $offset: Int
    $search: String
    $filters: FiltersType
    $processedPaymentsDateRange: [String]
  ) {
    getLandlordDashboard(
      limit: $limit
      offset: $offset
      search: $search
      filters: $filters
      processedPaymentsDateRange: $processedPaymentsDateRange
    ) {
      status
      message
      data {
        totalRentDue
        totalDefaultingPayments
        processingPayments
        processedPayments
        payments {
          count
          rows {
            status
            settlementStatus
            id
            createdAt
            actionDate
            tenant {
              account {
                accountNumber
                bankName
                email
                type
              }
              id
              leaseDuration
              rentAmount
              rentDueDay
              property {
                id
                propertyName
                propertyType
                rentalAddress
                description
              }
              user {
                lastName
                firstName
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_REALTOR_TENANTS = gql`
  query GetRealtorTenants($limit: Int, $offset: Int, $filter: TenantFilters) {
    getRealtorTenants(limit: $limit, offset: $offset, filter: $filter) {
      message
      status
      data {
        count
        tenants {
          createdAt
          createLevel
          documents {
            docKey
          }
          userId
          user {
            createdAt
            firstName
            lastName
            email
          }
          unit
          status
          rentDueDay
          rentAmount
          realtorId
          rentProtection
          leaseEndDate
          leaseStartDate
          realtorPropertyBedroomId
          realtorPropertyBedroomDetail {
            id
            roomName
            rentAmount
          }
          property {
            propertyName
            rentalAddress
            roomAvailability
          }
          leaseDuration
          isActive
          id
          updatedAt
          propertyId
        }
      }
    }
  }
`;

export const GET_REALTOR_PROPERTY_PRESET = gql`
  query GetRealtorPropertyPreset {
    getRealtorPropertyPreset {
      status
      message
      data {
        currentRentSchedules
        imageTypes
        paymentReminders
        propertyTypes
      }
    }
  }
`;

export const GET_VALIDATED_REALTOR_ACCOUNTS = gql`
  query GetValidatedRealtorAccounts {
    getValidatedRealtorAccounts {
      status
      message
      data {
        id
        accountNumber
        accountName
        bankName
        type
      }
    }
  }
`;

export const GET_CANADIAN_BANKS = gql`
  query Data {
    getCanadianBanks {
      data {
        institutionNumber
        financialInstitutionName
      }
    }
  }
`;

export const GET_A_TENANT = gql`
  query GetATenant($tenantId: String!) {
    getATenant(tenantId: $tenantId) {
      data {
        id
        isActive
        leaseDuration
        rentAmount
        rentDueDay
        status
        paymentStatus
        unit
        updatedAt
        leaseStartDate
        leaseEndDate
        unitNumbers
        realtorPropertyBedroomId
        realtorPropertyBedroomDetail {
          id
          roomName
          rentAmount
        }
        PADStatus
        account {
          accountNumber
          bankName
          email
          type
          bankCode
          transitCode
          accountName
        }
        propertyId
        createLevel
        property {
          id
          rentalAddress
          state
          city
          rentAmount
          roomAvailability
          realtorPropertyBedroomDetail {
            id
            roomName
            rentAmount
          }
        }
        user {
          firstName
          lastName
          email
          phone
          gender
          primaryAddress {
            city
            country
            houseNo
            AddressLine1
            addressType
            id
            isDefault
            lga
            location
            state
            status
            street
            zipCode
          }
          createdAt
          address {
            location
            city
            addressType
            AddressLine1
            state
            street
            zipCode
          }
        }
        documents {
          docKey
          documentType
          fileName
          file_ext
          id
          tenantId
          meta
        }
        rentProtection
        createdAt
      }
      message
      status
    }
  }
`;

export const GET_REALTOR_TRANSACTIONS_PAGINATED = gql`
  query GetRealtorTransactionsPaginated(
    $limit: Int
    $offset: Int
    $statusFilter: String
    $filter: RealtorTransactionsFiltersType
  ) {
    getRealtorTransactionsPaginated(
      limit: $limit
      offset: $offset
      statusFilter: $statusFilter
      filter: $filter
    ) {
      status
      data {
        count
        rows {
          id
          rentPayment {
            id
            actionDate
            status
            createdAt
            settlementStatus
            narration
            tenant {
              id
              rentAmount
              rentDueDay
              leaseDuration
              user {
                firstName
                lastName
              }
              account {
                email
                accountNumber
                bankName
                type
              }
              property {
                id
                rentalAddress
                propertyName
                propertyType
                description
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_EFT_BANK_LIST = gql`
  query GetEftBankList {
    getEftBankList {
      message
      status
      data {
        BankNumber
        Description
        Id
      }
    }
  }
`;

export const GET_EFT_BANK_BRANCH_LIST = gql`
  query GetEftBankBranchList($bankId: Int!) {
    getEftBankBranchList(bankId: $bankId) {
      message
      status
      data {
        Id
        Description
      }
    }
  }
`;

export const GET_REALTOR_ACCOUNTS = gql`
  query GetRealtorAccounts($filter: RealtorAccountFilter) {
    getRealtorAccounts(filter: $filter) {
      message
      status
      data {
        bankBranchId
        transitCode
        accountName
        bankName
        bankId
        accountNumber
        id
        type
        updatedAt
        createdAt
      }
    }
  }
`;

export const GET_PROPERTY_DETAILS_TENANT_PAGINATED = gql`
  query GetPropertyDetailsTenantPaginated(
    $getPropertyDetailsTenantPaginatedId: ID!
    $limit: Int
    $offset: Int
    $search: String
  ) {
    getPropertyDetailsTenantPaginated(
      id: $getPropertyDetailsTenantPaginatedId
      limit: $limit
      offset: $offset
      search: $search
    ) {
      status
      message
      data {
        count
        rows {
          rentAmount
          id
          createdAt
          user {
            firstName
            lastName
          }
          status
          realtorId
          property {
            rentalAddress
          }
          leaseDuration
          leaseStartDate
          leaseEndDate
        }
      }
    }
  }
`;

export const GET_ALL_REALTOR_PROPERTY_PAGINATED = gql`
  query GetAllRealtorPropertyPaginated(
    $limit: Int
    $offset: Int
    $statusFilter: String
    $search: String
    $allProperty: Boolean
  ) {
    getAllRealtorPropertyPaginated(
      limit: $limit
      offset: $offset
      statusFilter: $statusFilter
      search: $search
      allProperty: $allProperty
    ) {
      data {
        count
        rows {
          id
          propertyType
          propertyName
          rentalAddress
          unitAvaialable
          unitUsed
          unitUsed
          city
          state
          description
          managerFullName
          meta
          createdAt
          rentAmount
          typeOfHome
          bedroomCount
          roomAvailability
          bathroomCount
          realtorPropertyImages {
            id
            realtorPropertyId
            imageType
            s3Url
          }
          realtorPropertyBedroomDetail {
            bedCount
            id
            minimumStay
            preferredGender
            privateBath
            realtorPropertyBedroomImages {
              id
              realtorPropertyBedroomId
              realtorPropertyId
              s3Url
            }
            rentAmount
            roomAlias
            roomDetails
            roomFeatures
            roomName
          }
        }
      }
      message
      status
    }
  }
`;

export const GET_REALTOR_TRANSACTIONS_BY_ID = gql`
  query GetRealtorTransactionById($getRealtorTransactionByIdId: ID!) {
    getRealtorTransactionById(id: $getRealtorTransactionByIdId) {
      data {
        id
        rentPayment {
          id
          actionDate
          status
          createdAt
          settlementStatus
          tenant {
            id
            rentAmount
            rentDueDay
            leaseDuration
            property {
              id
              rentalAddress
              propertyName
              propertyType
              description
            }
            account {
              email
              accountNumber
              bankName
              type
            }
            user {
              firstName
              lastName
            }
          }
          narration
        }
      }
      message
      status
    }
  }
`;
export const GET_REALTOR_ACCOUNT_BY_ID = gql`
  query GetRealtorAccountById($accountId: String!) {
    getRealtorAccountById(accountId: $accountId) {
      status
      message
      data {
        id
        email
        accountNumber
        type
        bankId
        bankBranchId
        transitCode
        bankName
        bankCode
        accountName
        providerCustomerId
        realtorId
        createdAt
        updatedAt
      }
    }
  }
`;

export const GET_REALTOR_ACCOUNT_TRANSACTIONS_BY_ID = gql`
  query GetAccountTransactionByAccountId($accountId: String!, $limit: Int, $offset: Int) {
    getAccountTransactionByAccountId(accountId: $accountId, limit: $limit, offset: $offset) {
      count
      transactions {
        description
        amount
        createdAt
        id
        status
      }
    }
  }
`;

export const GET_REALTOR_PROPERTY_BY_ID = gql`
  query GetRealtorPropertyById($getRealtorPropertyByIdId: ID!) {
    getRealtorPropertyById(id: $getRealtorPropertyByIdId) {
      status
      message
      realtorProperty {
        id
        realtorId
        propertyName
        managerFullName
        managerPhone
        meta
        managerEmail
        propertyType
        description
        unitAvaialable
        unitUsed
        unitSize
        landmark
        roomAvailability
        proofOfOwnership
        keyFeatures
        otherFeatures
        rentalAddress
        city
        state
        zipCode
        paymentReminders
        isActive
        createdAt
        updatedAt
        typeOfHome
        bedroomCount
        rentAmount
        createLevel
        bathroomCount
        realtorPropertyImages {
          id
          realtorPropertyId
          imageType
          s3Url
        }
        realtorPropertyBedroomDetail {
          id
          realtorPropertyBedroomImages {
            id
            realtorPropertyId
            realtorPropertyBedroomId
            s3Url
          }
          roomAlias
          roomDetails
          roomName
          roomFeatures
          privateBath
          bedCount
          preferredGender
          minimumStay
          rentAmount
        }
        realtorPropertyOwnershipDoc {
          id
          realtorPropertyId
          s3Url
        }
      }
      otherPropertyListing {
        id
        realtorId
        propertyName
        managerFullName
        managerPhone
        managerEmail
        meta
        propertyType
        description
        unitAvaialable
        unitUsed
        unitSize
        keyFeatures
        otherFeatures
        rentalAddress
        city
        state
        zipCode
        paymentReminders
        isActive
        createdAt
        updatedAt
        typeOfHome
        bedroomCount
        bathroomCount
        rentAmount
        createLevel
        realtorPropertyImages {
          id
          realtorPropertyId
          imageType
          s3Url
        }
        realtorPropertyBedroomDetail {
          id
          realtorPropertyBedroomImages {
            id
            realtorPropertyId
            realtorPropertyBedroomId
            s3Url
          }
          roomAlias
          roomDetails
          roomName
          roomFeatures
          privateBath
          bedCount
          preferredGender
          minimumStay
          rentAmount
        }
        realtorPropertyOwnershipDoc {
          id
          realtorPropertyId
          s3Url
        }
      }
    }
  }
`;

export const GET_TENANT_TRANSACTIONS = gql`
  query GetTenantTransactions($tenantId: String!, $limit: Int!, $offset: Int!) {
    getTenantTransactions(tenantId: $tenantId, limit: $limit, offset: $offset) {
      message
      status
      data {
        count
        rows {
          createdAt
          dueDate
          graceDate
          id
          periodLabel
          receiptUrl
          rentAmount
          status
          statusPayment
        }
      }
    }
  }
`;

export const GET_ALL_LANDLORD_MATCH_REQUEST = gql`
  query GetAllLandlordMatchRequest($limit: Int, $offset: Int, $statusFilter: MatchStatusEnum) {
    getAllLandlordMatchRequest(limit: $limit, offset: $offset, statusFilter: $statusFilter) {
      status
      message
      data {
        count
        counts {
          approvedMatchCount
          rejectedMatchCount
          pendingMatchCount
          allMatchCount
        }
        rows {
          id
          createdAt
          status
          firstName
          lastName
          email
          realtorProperty {
            id
            propertyName
          }
        }
      }
    }
  }
`;

export const GET_ALL_LANDLORD_MATCH_REQUEST_V2 = gql`
  query GetAllLandlordMatchRequestV2($limit: Int, $offset: Int, $statusFilter: MatchStatusEnumV2) {
    getAllLandlordMatchRequestV2(limit: $limit, offset: $offset, statusFilter: $statusFilter) {
      status
      message
      data {
        count
        rows {
          applicationGroupId
          propertyId
          inviteCode
          status
          applicationType
          applicantCount
          displayName
          primaryApplicant {
            id
            userId
            firstName
            lastName
            email
            imageUrl
          }
          realtorProperty {
            id
            propertyName
          }
          members {
            id
            userId
            firstName
            lastName
            email
            phone
            gender
            dob
            imageUrl
            nationality
            canadianStatus
            employmentStatus
            monthlyIncome
            documents {
              documentType
              docKey
              signedUrl
            }
            reference
            shareProfileType
            status
            AMLCheck
            PEPCheck
            enrollment_type
            signzyExtractedNames
            meta
            applicantRole
            applicationGroupId
            isPrimaryApplicant
            applicationStatus
            groupCreatedByUserId
            realtorProperty {
              id
              propertyName
              rentalAddress
            }
          }
          createdAt
          updatedAt
        }
        counts {
          approvedMatchCount
          rejectedMatchCount
          pendingMatchCount
          allMatchCount
        }
      }
    }
  }
`;

export const GET_TENANT_MATCH_PROFILE = gql`
  query GetTenantMatchProfile($matchRequestId: ID!) {
    getTenantMatchProfile(matchRequestId: $matchRequestId) {
      status
      message
      data {
        firstName
        lastName
        id
        email
        phone
        status
        imageUrl
        AMLCheck
        PEPCheck
        meta
        signzyExtractedNames
        documents {
          documentType
          docKey
          signedUrl
        }
        realtorProperty {
          propertyName
        }
        enrollment_type
        shareProfileType
        applicationStatus
      }
    }
  }
`;

export const GET_MATCH_DOCUMENT_SIGNED_URL = gql`
  query GetMatchDocumentSignedUrl($matchRequestId: ID!, $docKey: String!) {
    getMatchDocumentSignedUrl(matchRequestId: $matchRequestId, docKey: $docKey) {
      status
      message
      signedUrl
    }
  }
`;

export const GET_REALTOR_AGREEMENTS = gql`
  query GetRealtorAgreement(
    $limit: Int!
    $offset: Int!
    $statusFilter: String
    $agreementType: String
  ) {
    getRealtorAgreement(
      limit: $limit
      offset: $offset
      statusFilter: $statusFilter
      agreementType: $agreementType
    ) {
      status
      message
      data {
        count
        rows {
          id
          realtorId
          tenantId
          agreementType
          agreementS3Url
          realtorSignatureS3Url
          tenantSignatureS3Url
          realtorSignedRequired
          tenantSignedRequired
          tenantView
          status
          meta
          createdAt
          updatedAt
        }
      }
    }
  }
`;

export const NOTIFY_TENANT_OF_REALTOR_AGREEMENT = gql`
  query NotifyTenantOfRealtorAgreement($realtorAgreementId: String!, $tenantId: String!) {
    notifyTenantOfRealtorAgreement(realtorAgreementId: $realtorAgreementId, tenantId: $tenantId) {
      status
      message
      data {
        id
        tenantView
        status
      }
    }
  }
`;

export const GET_REALTOR_AGREEMENT_BY_ID = gql`
  query GetRealtorAgreementById($realtorAgreementId: String!, $tenantId: String!) {
    getRealtorAgreementById(realtorAgreementId: $realtorAgreementId, tenantId: $tenantId) {
      status
      message
      data {
        id
        realtorId
        tenantId
        agreementType
        agreementS3Url
        realtorSignatureS3Url
        tenantSignatureS3Url
        realtorSignedRequired
        tenantSignedRequired
        tenantView
        status
        meta
        createdAt
        updatedAt
      }
    }
  }
`;
